
export function RInputDeclare(props) {
	return <label className={"text-14 text-gray3 mt-4 mb-4 " + props.className}>{props.value}{props.optional && <span className="pl-2 text-[#666A73] text-[14px]">*optional</span>}</label>;
}
